const initialState = {
  certificateData: null,
  loading: false,
  error: null,
};

export const certificateReducer = (state = initialState, action) => {
  switch (action.type) {
    case "CERT_VERIFY_REQUEST":
      return { ...state, loading: true, error: null };

    case "CERT_VERIFY_SUCCESS":
      return { ...state, loading: false, certificateData: action.payload };

    case "CERT_VERIFY_FAIL":
      return { ...state, loading: false, error: action.payload };

    case "CERT_CLEAR":
      return initialState;

    default:
      return state;
  }
};